module.exports = __webpack_public_path__ + "static/media/Ocean-new.ceaf3ce1.png";